<template>
  <Lenis :options="lenisOptions" root>
    <div class="section-1">
      <img width="146" height="70" src="https://s3.ap-northeast-2.amazonaws.com/cdn.insabank/main/insa-logo.png" alt="insa-logo" />
      <div class="section-title">
        <div>
          <div class="text blue">Total HR Service</div>
          <div class="text">KPI 한국인사관리협회</div>
        </div>
        <div class="search-wrap">
          <input type="text" :value="keyword" @input="inputMainPage($event)" placeholder="검색" @keyup.enter="searchMainPage" />
          <search-icon class="search-icon" @click="searchMainPage" />
        </div>
      </div>
      <div class="info-wrap">
        <div class="is-14r">HR 파트너, 인사관리의 모든 것</div>
        <div class="is-14r">Since 1976</div>
      </div>
    </div>

    <div class="section-3"><div class="section-2">
      <Swiper
        :modules="[Autoplay, Navigation]"
        :effect="'slide'"
        :speed="1000"
        :autoplay="{delay: 3000, disableOnInteraction: false}"
        :slides-per-view="1"
        :loop="true"
        :navigation="{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }"
        data-lenis-prevent
        class="mySwiper"
      >
        <SwiperSlide v-for="item in mainData.topList" :key="'top-banner' + item.id">
          <div :style="{backgroundImage: `url(${item.imgPath})`}" class="seminar-item" @click="onClickBanner(item)">
            <div class="title">{{ item.title }}</div>
            <div class="content">{{ item.content }}</div>
          </div>
        </SwiperSlide>
        <!-- 좌우 이동 버튼 추가 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </Swiper>
    </div>
      <div class="title">회원사업</div>
      <div class="sub-title is-16m">
        KPI 회원사업은 인사•교육담당 실무스태프 및 부서장, 임원들의 지속적인 정보교류와 상호협력,<br />
        최신 지식과 정보를 습득하는 월1회 정례모임으로 운영됩니다.
      </div>
      <div class="membership-box">
        <div class="box-left">
          <div :class="['member-type', {on: printCompanyCount.selectedType === 'MMT01'}]" @click="changeMembershipCompany('MMT01')">
            <div :class="['is-16b', {on: printCompanyCount.selectedType === 'MMT01'}]">한국인사관리자<br />월례미팅</div>
            <arrow-right :on="printCompanyCount.selectedType === 'MMT01'" />
          </div>
          <div :class="['member-type', {on: printCompanyCount.selectedType === 'MMT02'}]" @click="changeMembershipCompany('MMT02')">
            <div :class="['is-16b', {on: printCompanyCount.selectedType === 'MMT02'}]">교육연수담당자<br />월례미팅</div>
            <arrow-right :on="printCompanyCount.selectedType === 'MMT02'" />
          </div>
          <div :class="['member-type', {on: printCompanyCount.selectedType === 'MMT03'}]" @click="changeMembershipCompany('MMT03')">
            <div :class="['is-16b', {on: printCompanyCount.selectedType === 'MMT03'}]">인사팀(부)장 <br />교류회</div>
            <arrow-right :on="printCompanyCount.selectedType === 'MMT03'" />
          </div>
          <div :class="['member-type', {on: printCompanyCount.selectedType === 'MMT04'}]" @click="changeMembershipCompany('MMT04')">
            <div :class="['is-16b', {on: printCompanyCount.selectedType === 'MMT04'}]">KOREA CHO<br />FORUM</div>
            <arrow-right :on="printCompanyCount.selectedType === 'MMT04'" />
          </div>
        </div>
        <div class="box-right">
          <div class="company">
            <div class="company-top">
              <now-company-icon />
            </div>
            <div class="company-bot is-60b">{{ comma(printCompanyCount.now) }}</div>
          </div>
          <div class="company">
            <div class="company-top">
              <past-company-icon />
            </div>
            <div class="company-bot is-60b">{{ comma(printCompanyCount.past) }}</div>
          </div>
        </div>
      </div>
      <div class="membership-content">
        <div class="membership-content__item">
          <div class="item-cover">
            <div class="cover-index">01</div>
            <div class="cover-title">
              한국인사관리자<br />
              월례미팅
            </div>
          </div>
          <div class="item-hover">
            <div class="hover-wrap">
              <main-half-circle fill="#a8d0ef" class="half-circle" />
            </div>
            <div class="hover-index">01</div>
            <div class="hover-title">
              한국인사관리자<br />
              월례미팅
            </div>
            <div class="hover-content">
              국내 최대규모의 인사담당 스탭들의<br />
              정보•자료 교류의 場
            </div>
            <main-membership-item1 menu="0" class="hover-item1" />
          </div>
        </div>
        <div class="membership-content__item">
          <div class="item-cover">
            <div class="cover-index">02</div>
            <div class="cover-title">
              교육연수담당자<br />
              월례미팅
            </div>
          </div>
          <div class="item-hover">
            <div class="hover-wrap">
              <main-half-circle fill="#f7967c" class="half-circle" />
            </div>
            <div class="hover-index">02</div>
            <div class="hover-title">
              교육연수담당자<br />
              월례미팅
            </div>
            <div class="hover-content">
              국내 최고 권위의 HRD 담당 스탭들과<br />
              전문 交流의 場
            </div>
            <main-membership-item1 menu="1" class="hover-item1" />
          </div>
        </div>
        <div class="membership-content__item">
          <div class="item-cover">
            <div class="cover-index">03</div>
            <div class="cover-title">
              인사팀(부)장<br />
              교류회
            </div>
          </div>
          <div class="item-hover">
            <div class="hover-wrap">
              <main-half-circle fill="#5ac3b2" class="half-circle" />
            </div>
            <div class="hover-index">03</div>
            <div class="hover-title">
              인사팀(부)장<br />
              교류회
            </div>
            <div class="hover-content">
              HR 트렌드를 선도하고 품격있고,<br />
              차별화된 지혜와 정보·자료 交流의 場
            </div>
            <main-membership-item1 menu="2" class="hover-item1" />
          </div>
        </div>
        <div class="membership-content__item">
          <div class="item-cover">
            <div class="cover-index">04</div>
            <div class="cover-title">
              KOREA CHO<br />
              FORUM
            </div>
          </div>
          <div class="item-hover">
            <div class="hover-wrap">
              <main-half-circle fill="#c4abcc" class="half-circle" />
            </div>
            <div class="hover-index">04</div>
            <div class="hover-title">
              KOREA CHO<br />
              FORUM
            </div>
            <div class="hover-content">
              HR 수준을 한 단계 업그레이드 시키는<br />
              CHO만의 차별화된 네트워크
            </div>
            <main-membership-item1 menu="3" class="hover-item1" />
          </div>
        </div>
      </div>
    </div>
    <div class="section-4">
      <div class="is-40b">공개강좌</div>
      <div class="is-16m">
        KPI의 교육관련 정보를 보다 쉽고 편리하게 제공하고<br />
        강좌를 신청하도록 지원합니다.
      </div>
      <div class="navigation">
        <div
          v-for="(nav, index) in seminarNav"
          :key="'nav' + index"
          :class="['nav-item', 'cursor', {on: nav.selected}]"
          @click="onClickSeminarNav(nav.type)"
        >
          {{ nav.name }}
        </div>
      </div>
      <div class="seminar-list">
        <div
          v-for="(seminar, index) in paginatedSeminarList"
          :key="'smr' + seminar.id"
          class="seminar-item"
          @click="goSeminarDetail(seminar.id)"
          @mouseover="hoveredIndex = index"
          @mouseleave="hoveredIndex = null"
          :style="{borderBottom: hoveredIndex === index ? `1px solid ${seminar.color}` : '1px solid #dbdbdb'}"
        >
          <div class="is-14r" :style="{color: hoveredIndex === index ? seminar.color : '#1B1F22'}">
            {{ seminar.typeName }}
          </div>
          <div class="title-wrap">
            <div class="title" :style="{color: hoveredIndex === index ? seminar.color : '#1B1F22'}">
              {{ seminar.title }}
            </div>
            <div class="term" :style="{color: hoveredIndex === index ? seminar.color : '#606060'}">
              {{ seminar.term }}
            </div>
          </div>
          <div class="purpose" :style="{color: hoveredIndex === index ? seminar.color : '#909090'}">
            {{ seminar?.purpose ? seminar.purpose : 'ㅤ' }}
          </div>
        </div>
      </div>
      <div v-if="printSeminarList.length > itemsPerPage" class="seminar-page__wrap">
        <div
          v-for="page in totalPages"
          :key="page"
          :class="['is-14m', 'page-num', { active: currentPage === page }]"
          @click="changePage(page)"
        >
          {{ page }}
        </div>
      </div>
    </div>
    <div class="section-5">
      <div class="is-40b">월간인사관리</div>
      <div class="is-16m">국내외 HR관련 최신 동향과 정보, 사례 제공</div>
      <div class="apply-btn is-16b" @click="magazineApply">월간인사관리 구독 신청</div>
      <div class="magazine-wrap">
        <div class="year-list__wrap">
          <div class="year-list" data-lenis-prevent>
<!--            <div class="year-nav">-->
<!--              <div class="is-16r cursor" @click="yearDropDown = !yearDropDown">{{ nowYear }}년</div>-->
<!--              <gray-angle-icon class="nav-next" @click="yearDropDown = !yearDropDown" />-->
<!--              <div v-show="yearDropDown" class="year-dropdown">-->
<!--                <div-->
<!--                  v-for="(item, index) in mainData.magazineData.yearList"-->
<!--                  :key="'year' + index"-->
<!--                  class="drop-item is-16r cursor"-->
<!--                  @click="changeMainYear(item)"-->
<!--                >-->
<!--                  {{ item }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="more-btn is-16b" @click="goMagazineMonthly">전체 월호 보기</div>
            <div class="year-list__wrap">
                <div
                  v-for="magazine in mainData.magazineData.magazineList"
                  :key="'mgz' + magazine.id"
                  class="list-item cursor"
                  @click="onClickMagazine(magazine.id)"
                >
                  <img :src="magazine.imgPath" class="list-item__img" alt="img" />
                  <div class="is-14b">{{ magazine.title }}</div>
                </div>
            </div>
          </div>
<!--          <div class="more-btn is-16b" @click="goMagazineMonthly">전체 월호 보기</div>-->
        </div>
        <div>
          <div v-if="printMagazineList.length > 0" class="monthly-list">
            <div
              v-for="article in printMagazineList"
              :key="'article' + article.id"
              class="monthly-list__item cursor"
              @click="goMagazineBoard(article)"
            >
              <img :src="article.imgPath" alt="img" class="monthly-list__img" />
              <div class="content-wrap">
                <div class="monthly-list__title is-18r">{{ article.title }}</div>
                <div class="monthly-list__subtitle is-14r">{{ article.subtitle }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- KPI 도서 -->
    <div class="section-6">
      <div class="title">KPI 도서</div>
      <div class="sub-title is-16m">실무 실사례 중심의 HR관련 도서</div>
      <div class="btn-wrap" @click="goToKpiBook(null)">
        <div class="text">KPI도서 구입하기</div>
      </div>
      <div class="book-container">
        <div class="book-wrap">
          <div class="arrow-wrap left" @click="changeBookIndex('prev')">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_b_2095_13457)">
                <rect width="56" height="56" rx="28" fill="black" fill-opacity="0.25" />
                <path d="M31 34L25 28L31 22" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </g>
              <defs>
                <filter
                  id="filter0_b_2095_13457"
                  x="-32"
                  y="-32"
                  width="120"
                  height="120"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="16" />
                  <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2095_13457" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2095_13457" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
          <div
            v-for="(book, index) in printBookList"
            :key="book.id"
            :class="['book-item', {active: activeBookIndex === index}]"
            @click="goToKpiBook(book.id)"
          >
            <img :src="book.imgPath" alt="kpi-도서" class="book-cover" />
            <div class="title-wrap">
              <div class="book-title">{{ book.title }}</div>
              <div class="date">발행일 : {{ book.publicationDate }}</div>
            </div>
          </div>
          <div class="arrow-wrap right" @click="changeBookIndex('next')">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_b_2095_13455)">
                <rect width="56" height="56" rx="28" fill="black" fill-opacity="0.25" />
                <path d="M25 34L31 28L25 22" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </g>
              <defs>
                <filter
                  id="filter0_b_2095_13455"
                  x="-32"
                  y="-32"
                  width="120"
                  height="120"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="16" />
                  <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2095_13455" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2095_13455" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!-- HR 자료 -->
    <div class="section-7">
      <div class="title">HR 자료</div>
      <div class="sub-title is-16m">온라인상에서 쉽게 접할 수 없던 HR 자료를 빠르고 편리하게 열람하세요</div>
      <div class="btn-wrap" @click="goToHr(null)">
        <div class="text">HR 자료 구매하기</div>
      </div>
      <div class="hr-contanier">
        <!-- 연봉자료-->
        <div class="data-section">
          <div class="data-title">국내기업 연봉실태 조사</div>
          <div class="data-item__wrap">
            <div class="data-item">
              <img
                src="https://s3.ap-northeast-2.amazonaws.com/cdn.insabank/main/hr/HDT01.png"
                alt="hr-자료"
                class="data-cover"
                @click="onClickYearHrData()"
              />
              <div class="year-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  class="arrow-icon"
                  @click="onClickHrYearArrow('prev')"
                >
                  <path d="M10.5 12L6.5 8L10.5 4" stroke="#A2A9B0" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="year">{{ `${activeHrYear}년` }}</div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  class="arrow-icon"
                  @click="onClickHrYearArrow('next')"
                >
                  <path d="M6.5 12L10.5 8L6.5 4" stroke="#A2A9B0" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="sample-section">
          <div v-for="data in mainData.hrData['01']" :key="data.code" class="sample-item" @click="goToHr(data.code)">
            <img :src="`https://s3.ap-northeast-2.amazonaws.com/cdn.insabank/main/hr/${data.code}.png`" alt="hr-자료" class="sample-cover" />
            <div class="item-bottom">
              <div class="type-name">{{ data.name }}</div>
              <div class="data-desc">{{ data.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Section8 :advertise-list="mainData.bottomList" />
  </Lenis>
  <PopupModal v-if="isShowPopup" :popup="mainData.popup" @close="isShowPopup = false" />
</template>

<script>
import 'swiper/swiper-bundle.css';
import {useCookie} from '#app'
import {useCommonStore} from '~/store/common/index.js'
import {useMemberStore} from '~/store/member/index.js'
import {Autoplay, Pagination, Navigation} from 'swiper/modules'
import ArrowRight from 'assets/svg/arrow-right.vue'
import NowCompanyIcon from 'assets/svg/now-company-icon.vue'
import PastCompanyIcon from 'assets/svg/past-company-icon.vue'
import Section8 from '~/components/main/Section8.vue'
import {comma} from '~/utils/function.js'
import {getDate, getDiffDate} from '~/utils/CommonUtils.js'
import MainHalfCircle from 'assets/svg/main-half-circle.vue'
import MainMembershipItem1 from 'assets/svg/main-membership-item1.vue'
import GrayAngleIcon from 'assets/svg/gray-angle-icon.vue'
import SearchIcon from 'assets/svg/search-icon.vue'
import PopupModal from '~/components/main/modal/PopupModal.vue'

export default {
  components: {
    SearchIcon,
    GrayAngleIcon,
    MainMembershipItem1,
    MainHalfCircle,
    PastCompanyIcon,
    NowCompanyIcon,
    ArrowRight,
    Section8,
    PopupModal
  },
  setup() {
    const store = useCommonStore()
    const memberStore = useMemberStore()
    const lenisOptions = {
      duration: 2,
      easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
      // prevent 옵션 추가
      prevent: event => {
        return event.target.closest('[data-lenis-prevent]')
      }
    }
    return {store, memberStore, lenisOptions}
  },
  computed: {
    isAuthenticated() {
      return this.memberStore.isAuthenticated
    },
    paginatedSeminarList() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.printSeminarList.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.printSeminarList.length / this.itemsPerPage);
    }
  },
  data() {
    return {
      keyword: '',
      activeBookIndex: 2, // 항상 가운데 (5개 중 3번째)
      printBookList: [],
      currentStartIndex: 0, // 전체 리스트에서 현재 시작 인덱스,
      comma,
      Autoplay,
      Pagination,
      Navigation,
      nowYear: '',
      printCompanyCount: {
        now: 0,
        past: 0,
        selectedType: 'MMT01'
      },
      printSeminarList: [],
      hoverColor: '',
      seminarNav: [
        {
          name: '전체',
          type: 'SMT00',
          selected: true
        },
        {
          name: '인사 · 조직',
          type: 'SMT01',
          selected: false
        },
        {
          name: '노무 · 노사',
          type: 'SMT02',
          selected: false
        },
        {
          name: 'HRD',
          type: 'SMT03',
          selected: false
        },
        {
          name: '기타',
          type: 'SMT04',
          selected: false
        }
      ],
      printMagazineList: [],
      mainData: {
        topList: [
          {
            id: 0,
            imgPath: '',
            link: '',
            title: '',
            content: ''
          }
        ],
        membershipCompany: {
          MMT01: {
            now: 0,
            past: 0
          },
          MMT02: {
            now: 0,
            past: 0
          },
          MMT03: {
            now: 0,
            past: 0
          },
          MMT04: {
            now: 0,
            past: 0
          }
        },
        seminarList: [
          {
            id: 0,
            title: '',
            type: '',
            typeName: '',
            purpose: '',
            term: '',
            color: ''
          }
        ],
        magazineData: {
          yearList: [],
          magazineList: [
            {
              id: 0,
              title: '',
              imgPath: '',
              articleList: [
                {
                  id: 0,
                  title: '',
                  subtitle: '',
                  imgPath: ''
                }
              ]
            }
          ]
        },
        kpiBookList: [
          {
            id: 0,
            title: '',
            publicationDate: '',
            imgPath: ''
          }
        ],
        hrData: {
          yearList: [],
          '01': [
            {
              code: '',
              name: '',
              desc: ''
            }
          ],
          '02': [
            {
              id: 0,
              year: '',
              previewImgPath: ''
            }
          ]
        },
        bottomList: [
          {
            id: 0,
            imgPath: '',
            link: ''
          }
        ],
        popup: {
          id: 0,
          imgPath: '',
          link: '',
          isShow: false,
          endDate: ''
        }
      },
      activeHrYear: '',
      yearDropDown: false,
      isShowPopup: false,
      hoveredIndex: null,
      currentPage: 1,
      itemsPerPage: 4,
    }
  },
  async mounted() {
    await this.getMainLanding()
    this.initMakePrintBookList()
    this.changeMembershipCompany(this.printCompanyCount.selectedType)
    this.popupCheck()
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },
    onClickBanner(item) {
      if ( item.link ){
        window.open(item.link, '_blank')
      }
    },
    popupCheck() {
      const popupCookie = useCookie('popupBlock')
      // 팝업 차단 안했고, 팝업 노출 설정이 되어있으면 팝업 노출
      if (!popupCookie.value && this.mainData.popup.isShow && this.mainData.popup.endDate) {
        // endDate 체크
        const today = getDate(0);
        const endDate = this.mainData.popup.endDate;
        const diff = getDiffDate(today, endDate);
        if ( diff >= 0 ){
          this.isShowPopup = true
        }
      }
    },
    onClickYearHrData() {
      if (!this.isAuthenticated) {
        alert('로그인 후 이용해주세요.')
        return
      }
      const hrData = this.mainData.hrData['02'].find(data => data.year === this.activeHrYear)
      this.$router.push(`/hr/${hrData.id}`)
    },
    onClickHrYearArrow(type) {
      if (type === 'prev') {
        const prevIndex = this.mainData.hrData.yearList.indexOf(this.activeHrYear) + 1
        const year = this.mainData.hrData.yearList[prevIndex]
        if (year) {
          this.activeHrYear = year
        }
      } else {
        const nextIndex = this.mainData.hrData.yearList.indexOf(this.activeHrYear) - 1
        const year = this.mainData.hrData.yearList[nextIndex]
        if (year) {
          this.activeHrYear = year
        }
      }
    },
    inputMainPage(event) {
      this.keyword = event.target.value
    },
    searchMainPage() {
      this.$router.push(`/search?keyword=${this.keyword}`)
    },
    goMagazineBoard(article) {
      const subMenu = Number(article.type)
      this.$router.push(`/magazine/board/${article.id}?subMenu=${subMenu}`)
    },
    goMagazineMonthly() {
      this.$router.push(`/magazine?menu=2&subMenu=0`)
    },
    goToHr(code) {
      if (!code) {
        this.$router.push(`/hr`)
      } else {
        this.$router.push(`/hr?menu=0&subMenu=0&code=${code}`)
      }
    },
    changeArticle(id) {
      // mainData.magazineData.magazineList 의 ID 의 articleList 를 printMagazineList 에 넣어주기
      const magazine = this.mainData.magazineData.magazineList.find(magazine => magazine.id === id)
      this.printMagazineList = magazine.articleList
    },
    onClickMagazine(magazineId){
      this.$router.push(`/magazine/${magazineId}`)
    },
    magazineApply() {
      this.$router.push(`/magazine?menu=3&subMenu=0`)
    },
    goToKpiBook(bookId) {
      if (!bookId) {
        this.$router.push(`/kpi-book`)
      } else {
        this.$router.push(`/kpi-book/${bookId}`)
      }
    },
    // 5개의 도서를 선택하여 출력 리스트 생성
    initMakePrintBookList() {
      const totalBooks = this.mainData.kpiBookList
      const totalLength = totalBooks.length
      // 시작 인덱스가 유효한 범위 내에 있도록 조정
      if (this.currentStartIndex < 0) {
        this.currentStartIndex = totalLength - 1
      } else if (this.currentStartIndex >= totalLength) {
        this.currentStartIndex = 0
      }
      let books = []
      for (let i = 0; i < 5; i++) {
        // 순환식으로 인덱스 계산
        let index = (this.currentStartIndex + i) % totalLength
        if (index < 0) index = totalLength + index
        books.push(totalBooks[index])
      }
      // books에서 id가 값이 가장 높은 책을 가운데에 넣고 나머지는 순서대로 넣기
      const sortedBooks = [];
      // books의 0번째 요소를 가운데에 넣기
      sortedBooks.push(books[1])
      sortedBooks.push(books[2])
      sortedBooks.push(books[0])
      sortedBooks.push(books[3])
      sortedBooks.push(books[4])
      this.printBookList = sortedBooks
      // sortedBooks에 나머지 안들어간거 다 넣기
      const remainBooks = totalBooks.filter(book => !sortedBooks.includes(book))
      const initBooks = [];
      initBooks.push( ...sortedBooks )
      initBooks.push(...remainBooks)
      this.mainData.kpiBookList = initBooks
    },
    // 5개의 도서를 선택하여 출력 리스트 생성
    makePrintBookList() {
      const totalBooks = this.mainData.kpiBookList
      const totalLength = totalBooks.length
      // 시작 인덱스가 유효한 범위 내에 있도록 조정
      if (this.currentStartIndex < 0) {
        this.currentStartIndex = totalLength - 1
      } else if (this.currentStartIndex >= totalLength) {
        this.currentStartIndex = 0
      }
      let books = []
      for (let i = 0; i < 5; i++) {
        // 순환식으로 인덱스 계산
        let index = (this.currentStartIndex + i) % totalLength
        if (index < 0) index = totalLength + index
        books.push(totalBooks[index])
      }
      this.printBookList = books
    },
    // 좌우 버튼 클릭 시 슬라이드 처리
    changeBookIndex(type) {
      if (type === 'prev') {
        this.currentStartIndex--
      } else if (type === 'next') {
        this.currentStartIndex++
      }
      this.makePrintBookList()
    },
    changeMainYear(year) {
      this.yearDropDown = false
      this.nowYear = year
      this.getMainLanding(year)
    },
    onClickSeminarNav(type) {
      this.seminarNav.forEach(nav => {
        nav.selected = nav.type === type
      })
      // type 이 SMT00 이면 this.printSeminarList = this.mainData.seminarList 나머지는 type에 맞는거만
      if (type === 'SMT00') {
        this.printSeminarList = this.mainData.seminarList
      } else {
        this.printSeminarList = this.mainData.seminarList.filter(seminar => seminar.type === type)
      }
      this.currentPage = 1 // 페이지 초기화
    },
    goSeminarDetail(id) {
      this.$router.push(`/seminar/${id}`)
    },
    async getMainLanding(year) {
      try {
        const {data} = await this.store.getMainLanding(year)
        this.mainData = data
        this.activeHrYear = data.hrData.yearList[0]
        this.printSeminarList = this.mainData.seminarList
        this.printMagazineList = this.mainData.magazineData.magazineList[0].articleList
        if (!year) this.nowYear = data.magazineData.yearList[0]
        // isShowPopup 체크
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    // printCompanyCount
    changeMembershipCompany(type) {
      const targetNow = this.mainData.membershipCompany[type].now
      const targetPast = this.mainData.membershipCompany[type].past

      const duration = 1000 // 애니메이션 지속 시간 (밀리초)
      const steps = 50 // 애니메이션 단계 수

      let currentNow = 0
      let currentPast = 0

      const intervalNow = setInterval(() => {
        currentNow += Math.ceil(targetNow / steps)
        if (currentNow >= targetNow) {
          currentNow = targetNow
          clearInterval(intervalNow)
        }
        this.printCompanyCount.now = currentNow
      }, duration / steps)

      const intervalPast = setInterval(() => {
        currentPast += Math.ceil(targetPast / steps)
        if (currentPast >= targetPast) {
          currentPast = targetPast
          clearInterval(intervalPast)
        }
        this.printCompanyCount.past = currentPast
      }, duration / steps)

      this.printCompanyCount.selectedType = type
    }
  }
}
</script>

<style lang="scss" scoped>
.section-1 {
  width: 1080px;
  margin: 0 auto;
  padding: 58px 0 62px;

  .section-title {
    margin-bottom: 36px;
    display: flex;
    gap: 20px;
    align-items: flex-end;

    .text {
      font-family: 'Godo', sans-serif;
      font-size: 56px;
      font-weight: 700;

      &.blue {
        color: #0058aa;
        margin-bottom: -20px;
      }
    }

    .search-wrap {
      padding: 12px 20px;
      width: 533px;
      border-radius: 100px;
      border: 1px solid #dbdbdb;
      background: #fff;
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;

      input {
        border: none;
        width: 100%;
        outline: none;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 17.5px */
        &::placeholder {
          color: #bdbdbd;
        }
      }

      .search-icon {
        cursor: pointer;
      }
    }
  }

  .info-wrap {
    display: flex;
    justify-content: space-between;
  }
}

.section-2 {
  margin-bottom: 120px;
  position: relative;

  .mySwiper {
    width: 1080px;
    margin: 0 auto;
    position: relative;
  }

  .seminar-item {
    cursor: pointer;
    margin: 0 auto;
    width: 1080px;
    height: 360px;
    border-radius: 20px;
    padding: 40px 80px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-size: cover;
    background-position: center;

    .title {
      width: 100%;
      height: 48px;
      background: transparent;
      font-family: Godo;
      font-size: 36px;
      font-weight: 700;
      color: #fff;
    }

    .content {
      width: 100%;
      height: 230px;
      padding-top: 8px;
      background: transparent;
      font-family: Godo;
      font-size: 24px;
      font-weight: 700;
      color: #fff;
      white-space: pre-line;
    }
  }

  /* Swiper 버튼 스타일 개선 - 회색 배경 적용 */
  .swiper-button-prev,
  .swiper-button-next {
    width: 50px; /* 크기 유지 */
    height: 50px;
    background: linear-gradient(135deg, rgba(100, 100, 100, 0.9), rgba(150, 150, 150, 0.7)); /* 회색 그라디언트 배경 */
    border-radius: 12px; /* 둥근 사각형 유지 */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); /* 부드러운 그림자 유지 */
    color: #fff; /* 화살표 색상 유지 */
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease; /* 호버 애니메이션용 */
  }

  /* 이전 버튼 */
  .swiper-button-prev {
    left: 20px; /* 여백 살짝 늘림 */
    &::after { /* 기본 화살표 커스터마이징 */
      font-size: 20px; /* 화살표 크기 조정 */
      font-weight: bold;
    }
  }

  /* 다음 버튼 */
  .swiper-button-next {
    right: 20px; /* 여백 살짝 늘림 */
    &::after {
      font-size: 20px;
      font-weight: bold;
    }
  }

  /* 비활성화 상태 */
  .swiper-button-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: translateY(-50%) scale(1); /* 호버 효과 무효화 */
  }
}

.section-3 {
  margin: 56px auto;
  width: 1080px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .title {
    font-size: 40px;
    font-weight: 700;
    font-family: 'Godo', sans-serif;
    margin-bottom: 16px;
    color: #1b1f22;
  }

  .sub-title {
    text-align: center;
    color: #606060;
    margin-bottom: 48px;
  }

  .membership-box {
    background: url('https://s3.ap-northeast-2.amazonaws.com/cdn.insabank/main/sec3-bg.png') no-repeat;
    padding: 16px 48px;
    border-radius: 20px;
    background-color: #f6f7f9;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 48px;

    .box-left {
      width: 300px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .member-type {
        width: 136px;
        height: 56px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        &.on {
          text-decoration: underline #0058aa;
        }

        .is-16b {
          &.on {
            color: #0058aa;
          }
        }
      }
    }

    .box-right {
      display: flex;
      gap: 64px;

      .company {
        width: 155px;

        .company-top {
          display: flex;
          align-items: center;
          gap: 4px;
          color: #0058aa;
        }
      }
    }
  }

  .membership-content {
    display: flex;
    gap: 24px;

    .membership-content__item {
      position: relative;
      width: 252px;
      height: 460px;
      overflow: hidden;
      border-radius: 20px;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);

      &:hover {
        .item-cover {
          transform: translateY(-100%);
        }

        .item-hover {
          transform: translateY(0);
        }
      }

      &:first-child {
        .cover-index,
        .cover-title {
          color: #a8d0ef;
        }

        .item-hover {
          background-color: #a8d0ef;
        }
      }

      &:nth-child(2) {
        .cover-index,
        .cover-title {
          color: #f7967c;
        }

        .item-hover {
          background-color: #f7967c;
        }
      }

      &:nth-child(3) {
        .cover-index,
        .cover-title {
          color: #5ac3b2;
        }

        .item-hover {
          background-color: #5ac3b2;
        }
      }

      &:last-child {
        .cover-index,
        .cover-title {
          color: #c4abcc;
        }

        .item-hover {
          background-color: #c4abcc;
        }
      }

      .item-cover,
      .item-hover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        transition: transform 0.3s ease;
      }

      .item-cover {
        border-radius: 20px;
        background: #fff;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
        width: 252px;
        height: 460px;
        display: flex;
        flex-direction: column;
        text-align: center;
        padding-top: 16px;
        z-index: 2;

        .cover-index {
          font-size: 80px;
          font-family: 'Godo', sans-serif;
          font-weight: 700;
          height: 110px;
        }

        .cover-title {
          font-size: 24px;
          font-weight: 700;
          font-family: 'Godo', sans-serif;
        }
      }

      .item-hover {
        width: 252px;
        height: 460px;
        display: flex;
        flex-direction: column;
        text-align: center;
        padding-top: 16px;
        transform: translateY(100%);
        z-index: 3;

        .hover-wrap {
          position: relative;

          .half-circle {
            position: absolute;
            top: -76px;
            left: 0;
            right: 0;
            margin: 0 auto;
          }
        }

        .hover-index {
          font-size: 80px;
          font-family: 'Godo', sans-serif;
          font-weight: 700;
          color: #fff;
          height: 110px;
        }

        .hover-title {
          font-size: 24px;
          font-weight: 700;
          font-family: 'Godo', sans-serif;
          color: #fff;
          margin-bottom: 4px;
        }

        .hover-content {
          color: #fff;
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          margin-bottom: 16px;
        }

        .hover-item1 {
          margin-bottom: 8px;
        }
      }
    }
  }
}

.section-4 {
  width: 1080px;
  margin: 0 auto;
  padding: 32px 0;

  .is-40b {
    font-size: 40px;
    font-weight: 700;
    font-family: 'Godo', sans-serif;
    margin-bottom: 10px;
    color: #1b1f22;
    text-align: center;
  }

  .is-16m {
    text-align: center;
    color: #606060;
    margin-bottom: 48px;
  }

  .navigation {
    display: flex;
    gap: 24px;
    border-bottom: 1px solid #dbdbdb;
    margin-bottom: 48px;

    .nav-item {
      width: 196px;
      color: #909090;
      padding-bottom: 8px;
      font-size: 16px;
      font-family: 'Godo', sans-serif;
      font-weight: 700;

      &.on {
        color: #1b1f22;
        border-bottom: 2px solid #1b1f22;
      }
    }
  }

  .seminar-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    cursor: pointer;
    min-height: 612px;

    .seminar-item {
      .is-14r {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        margin-bottom: 16px;
      }

      .title-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .title {
          font-size: 20px;
          font-family: 'Godo', sans-serif;
          font-weight: 700;
        }

        .term {
          color: #606060;
          font-size: 20px;
          font-weight: 400;
        }
      }

      .purpose {
        color: #909090;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        padding-bottom: 24px;
      }
    }
  }

  .seminar-page__wrap {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    .page-num {
      cursor: pointer;
      padding: 3px 8px;
      border-radius: 4px;
      border: 1px solid #dbdbdb;
      background: #fff;
      color: #909090;

      &.active {
        color: #fff;
        border: 1px solid #1b1f22;
        background: #1b1f22;
      }
    }
  }
}

.section-5 {
  width: 1080px;
  margin: 0 auto;
  padding: 120px 0;

  .is-40b {
    font-size: 40px;
    font-weight: 700;
    font-family: 'Godo', sans-serif;
    margin-bottom: 10px;
    color: #1b1f22;
    text-align: center;
  }

  .is-16m {
    text-align: center;
    color: #606060;
    margin-bottom: 48px;
  }

  .apply-btn {
    width: 186px;
    height: 48px;
    border-radius: 12px;
    border: 1px solid var(--Cool-Gray-Cool-Gray-100, #dde1e6);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #4d5358;
    margin: 0 auto 60px;
  }

  .magazine-wrap {
    display: flex;
    gap: 24px;

    .year-list {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

    .year-list::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }

    .year-list__wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 16px;

      .year-list {
        display: flex;
        flex-direction: column;
        gap: 24px;
        border-radius: 20px;
        background: rgba(0, 107, 206, 0.05);
        padding: 24px 36px;
        min-width: 252px;
        max-width: 252px;
        min-height: 536px;
        max-height: 536px;

        .year-nav {
          display: flex;
          align-items: center;
          gap: 4px;
          margin-bottom: 24px;
          justify-content: center;

          .nav-next {
            transform: rotate(269deg);
          }

          position: relative;

          .year-dropdown {
            top: 30px;
            gap: 8px;
            border-radius: 4px;
            position: absolute;
            background: #fff;
            padding: 16px;
            display: flex;
            flex-direction: column;
          }
        }

        .year-list__wrap {
          display: flex;
          flex-direction: column;
          gap: 24px;

          .list-item {
            .list-item__img {
              width: 177px;
              height: 233px;
              margin-bottom: 8px;
              box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
            }

            .is-14b {
              text-align: center;
            }
          }
        }
      }

      .more-btn {
        height: 48px;
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 12px;
        border: 1px solid var(--Cool-Gray-Cool-Gray-100, #dde1e6);
        background: #f2f7fc;
      }
    }

    .monthly-list {
      display: flex;
      gap: 24px;
      flex-wrap: wrap;

      .monthly-list__item {
        width: 252px;
        height: 256px;
        border-radius: 16px;
        border: 1px solid var(--Cool-Gray-Cool-Gray-50, #f2f4f8);
        background: var(--Shades-White, #fff);

        .monthly-list__img {
          border-radius: 16px 16px 0 0;
        }

        .content-wrap {
          padding: 16px;

          .monthly-list__title {
            // 길면 elipsis 처리
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .monthly-list__subtitle {
            color: #697077;
          }
        }
      }
    }
  }
}

.section-6 {
  margin: 56px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .title {
    font-size: 40px;
    font-weight: 700;
    font-family: 'Godo', sans-serif;
    margin-bottom: 8px;
    color: #21272a;
  }

  .sub-title {
    text-align: center;
    color: #697077;
    margin-bottom: 24px;
  }

  .btn-wrap {
    cursor: pointer;
    display: flex;
    border-radius: 12px;
    border: 1px solid #dde1e6;
    height: 48px;
    padding: 0 20px;
    justify-content: center;
    align-items: center;

    .text {
      color: var(--Cool-Gray-Cool-Gray-600, #4d5358);
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 150% */
    }
  }

  .book-container {
    position: relative;
    margin: 60px auto 120px;

    .book-wrap {
      display: flex;
      gap: 32px;
      justify-content: center;
      -ms-overflow-style: none;
      scrollbar-width: none;
      padding: 40px 0;
      min-height: 500px;

      .arrow-wrap {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 99;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        &.left {
          left: calc(50% - 400px);
        }

        &.right {
          right: calc(50% - 400px);
        }
      }

      .book-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
        width: 226px;
        opacity: 0.3;
        filter: grayscale(50%);
        transition: all 0.3s ease;

        .book-cover {
          width: 178px;
          height: 267px;
        }

        .title-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          transition: opacity 0.3s ease;
          opacity: 0.5;

          .book-title {
            color: var(--Cool-Gray-Cool-Gray-800, #21272a);
            text-align: center;
            /* Paragraph/P18-b */
            font-family: Pretendard;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 26px; /* 144.444% */
            letter-spacing: -0.036px;
          }

          .date {
            color: var(--Cool-Gray-Cool-Gray-500, #697077);
            text-align: center;
            /* Paragraph/P14-r */
            font-family: Pretendard;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; /* 157.143% */
            letter-spacing: -0.028px;
          }
        }

        &.active {
          opacity: 1;
          width: 267px;
          filter: grayscale(0%);
          transform: scale(1);
          z-index: 2;
          cursor: pointer;

          .book-cover {
            width: 267px;
            height: 400.5px;
          }

          .title-wrap {
            opacity: 1;
          }
        }
      }
    }
  }
}

.section-7 {
  margin: 56px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .title {
    font-size: 40px;
    font-weight: 700;
    font-family: 'Godo', sans-serif;
    margin-bottom: 8px;
    color: #21272a;
  }

  .sub-title {
    text-align: center;
    color: #697077;
    margin-bottom: 24px;
  }

  .btn-wrap {
    cursor: pointer;
    display: flex;
    border-radius: 12px;
    border: 1px solid #dde1e6;
    height: 48px;
    padding: 0 20px;
    justify-content: center;
    align-items: center;

    .text {
      color: var(--Cool-Gray-Cool-Gray-600, #4d5358);
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 150% */
    }
  }

  .hr-contanier {
    display: flex;
    gap: 24px;
    position: relative;
    margin: 60px auto 0;

    .data-section {
      display: flex;
      flex-direction: column;
      width: 252px;
      height: 384px;
      box-sizing: border-box;
      border-radius: 20px;
      background: rgba(0, 107, 206, 0.05);
      align-items: center;
      justify-content: center;

      .data-title {
        color: var(--Cool-Gray-Cool-Gray-800, #21272a);
        /* Paragraph/P16-r */
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
        letter-spacing: -0.032px;
        margin-top: 24px;
        margin-bottom: 24px;
      }

      .data-item__wrap {
        display: flex;
        flex-direction: column;
        padding: 0 40px;
        height: 320px;
        gap: 24px;

        .data-item {
          display: flex;
          flex-direction: column;
          gap: 8px;
          align-items: center;

          .data-cover {
            cursor: pointer;
            width: 177px;
            height: 253px;
            border-radius: 12px;
            box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.12);
          }

          .year-wrap {
            display: flex;
            gap: 8px;
            align-items: center;

            .year {
              color: var(--Cool-Gray-Cool-Gray-800, #21272a);

              /* Paragraph/P16-r */
              font-family: Pretendard;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 24px; /* 150% */
              letter-spacing: -0.032px;
            }

            .arrow-icon {
              cursor: pointer;
            }
          }
        }
      }
    }

    .sample-section {
      display: flex;
      gap: 24px;
      width: 804px;
    }

    .sample-item {
      position: relative;
      cursor: pointer;
      height: 384px;
      border: 1px solid #dbdbdb;
      border-radius: 20px;
      overflow: hidden;

      .sample-cover {
        width: 100%;
        //height: 100%;
        //object-fit: cover;
      }

      .item-bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #fff;
        border-top: 1px solid #dbdbdb;
        box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.12);
        display: flex;
        flex-direction: column;
        height: 98px;
        padding: 16px;
        z-index: 1;

        .type-name {
          color: var(--Cool-Gray-Cool-Gray-800, #21272a);
          font-family: Pretendard;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 26px;
          letter-spacing: -0.036px;
          margin-bottom: 4px;
        }

        .data-desc {
          color: #909090;
          font-family: Pretendard;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 125%;
          letter-spacing: -0.028px;
        }
      }
    }
  }
}
</style>
